<div class="model-directions-form feedback-form h-100">
    <div class="prediction-wrapper">
        <div class="section-title">Select prediction by run date...</div>
        <div class="prediction-data-form">
            <div class="run-selector">
           
                <div class="selection-block prediction-date-container">
                    <app-prediction-selector 
                      [runs]="runsData()"
                      [isLoading]="isPredictionLoading"
                      [isDisabled]="isFieldDisabled()"
                      [placeholder]="'Select a prediction by run date'"
                      (selectionChange)="onRunSelected($event)">
                    </app-prediction-selector>
                </div>
      
            </div>
            <div class="run-details">
              <div class="run-details-container">
                  <div *ngFor="let detail of predictionDetails()" class="run-detail">
                      <div class="detail-item">{{ detail.description }}</div>
                  </div>
              </div>
            </div>
        </div>
        

    </div>

    <div class="divider"> <p-divider layout="vertical"></p-divider></div>

    <div class="feedback-wrapper">
        <div class="free-text">
            <label>Additional commentary</label>
            <textarea pInputTextarea [(ngModel)]="freeText"
            [disabled]="isFieldDisabled()"
            (input)=" validateFreeText($event)"
            rows="7" cols="30" placeholder="Enter your comments here..."></textarea>

        </div>
    </div>
</div>
